import {ClientSolicitationFlow, ClientSolicitationFlowFields} from "../../../../../types/flow/flowData";
import {DataGrid, esES} from "@mui/x-data-grid";
import React, {useState} from "react";
import {Stack, Typography} from "@mui/material";
import {dateFormatter} from "../../../../../utils/formatters";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import {DeleteIconButton, EditIconButton} from "../../../../../components/buttons/Buttons";
import {EntityWithIdFields} from "../../../../../types/baseEntities";


interface CompanyEconomicSituationDataGridProps {
    flows: ClientSolicitationFlow[],
    onEdit?: (flow: ClientSolicitationFlow) => void,
    onDelete?: (flowId: number) => void
}


const CompanyEconomicSituationDataGrid = ({flows, onEdit, onDelete}: CompanyEconomicSituationDataGridProps) => {
    const [pageSize, setPageSize] = useState<number>(5)

    const cols = [
        {
            flex: 0.3,
            field: 'dtmFecha',
            minWidth: 130,
            headerName: 'Periodo',
            renderCell: (params: any) => (
                <Typography fontSize={13} fontWeight={500}>{dateFormatter.toMonthAndYearDate(params.row[ClientSolicitationFlowFields.Date])}</Typography>
            ),
            id: 1
        },
        {
            flex: 0.4,
            minWidth: 150,
            field: 'decIngresos',
            headerName: 'Monto de Compras (Netas de IVA)',
            renderCell: (params: any) => (
                <Typography fontSize={13} fontWeight={500}>{numberFormatter.toStringWithAmount(params.row[ClientSolicitationFlowFields.Incomes], '$')}</Typography>
            )
        },
        {
            flex: 0.4,
            minWidth: 150,
            field: 'decVentas',
            headerName: 'Monto de Ventas (Netas de IVA)',
            renderCell: (params: any) => (
                <Typography fontSize={13} fontWeight={500}>{numberFormatter.toStringWithAmount(params.row[ClientSolicitationFlowFields.Sales], '$')}</Typography>
            )
        },
        {
            flex: 0.1,
            field: 'actions',
            headerName: 'Acciones',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                    <EditIconButton onClick={() => {onEdit && onEdit(params.row as ClientSolicitationFlow)}} tooltipTitle={'Editar'}/>
                    <DeleteIconButton onClick={() => {onDelete && onDelete(params.row[EntityWithIdFields.Id])}} tooltipTitle={'Eliminar'}/>
                </Stack>
            )
        }
    ]

    const colsView = [
        {
            flex: 0.3,
            field: 'dtmFecha',
            minWidth: 130,
            headerName: 'Periodo',
            renderCell: (params: any) => (
                <Typography fontSize={13} fontWeight={500}>{dateFormatter.toMonthAndYearDate(params.row[ClientSolicitationFlowFields.Date])}</Typography>
            ),
            id: 1
        },
        {
            flex: 0.4,
            minWidth: 150,
            field: 'decIngresos',
            headerName: 'Monto de Compras (Netas de IVA)',
            renderCell: (params: any) => (
                <Typography fontSize={13} fontWeight={500}>{numberFormatter.toStringWithAmount(params.row[ClientSolicitationFlowFields.Incomes], '$')}</Typography>
            )
        },
        {
            flex: 0.4,
            minWidth: 150,
            field: 'decVentas',
            headerName: 'Monto de Ventas (Netas de IVA)',
            renderCell: (params: any) => (
                <Typography fontSize={13} fontWeight={500}>{numberFormatter.toStringWithAmount(params.row[ClientSolicitationFlowFields.Sales], '$')}</Typography>
            )
        }
        ]
    
    return (
        <DataGrid columns={(onEdit && onDelete) ? cols : colsView}
                  rows={flows}
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  autoHeight
                  rowsPerPageOptions={[5, 10, 25]}
                  pageSize={pageSize}
                  onPageSizeChange={newPageSize => setPageSize(newPageSize)}
        />
    )
}


export default CompanyEconomicSituationDataGrid